import jwt_decode from "jwt-decode";

export const decode_Token = (token) => {
    return jwt_decode(token,{payload:true})
}